import store from "../store";
import _ from "lodash";
import AutomationMenuItems from "../views/Pages/Automation/AutomationMenuItems";

const SYSTEM_ENABLED = true;
let singletonInstance;

const INTEGRATION_PAGE_FEATURE = {
    "whatsapp-v2": "whatsappEntegration",
    whatsapp: "whatsappEntegration",
    "whatsapp-business-api": "whatsappEntegration",
    "whatsapp-business-api-supsis": "whatsappEntegration",
    instagram: "instagramEntegration",
    "instagram-v2": "instagramEntegration",
    messenger: "messengerEntegration",
    "sms-postacell": "smsEntegration",
    trendyol: "trendyolEntegration",
};

const INTEGRATION_CHANNEL_FEATURE = {
    "whatsapp-v2": "maxWhatsappChannel",
    whatsapp: "maxWhatsappChannel",
    "whatsapp-business-api": "maxBusinessWhatsappChannel",
    "whatsapp-business-api-supsis": "maxBusinessWhatsappChannel",
    instagram: "maxInstagramChannel",
    "instagram-v2": "maxInstagramChannel",
    messenger: "maxMessengerChannel",
    telegram: "maxTelegramChannel",
    trendyol: "maxTrendyolChannel",
    "meta-leads": "maxMetaLeadChannel",
    "telegram-unipile": "maxTelegramChannel",
    "whatsapp-unipile": "maxWhatsappChannel",
    "linkedin-unipile": "maxLinkedinChannel",
    "webphone-kirmizisantral": "maxWebphoneChannel",
    "webphone-telnyx": "maxWebphoneChannel",
    webphone: "maxWebphoneChannel",
};

const INTEGRATION_CHANNEL_TYPES = {
    "whatsapp-unipile": ["whatsapp-v2", "whatsapp", "whatsapp-unipile"],
    "whatsapp-v2": ["whatsapp-v2", "whatsapp", "whatsapp-unipile"],
    whatsapp: ["whatsapp-v2", "whatsapp", "whatsapp-unipile"],
    instagram: ["instagram", "instagram-v2"],
    "instagram-v2": ["instagram", "instagram-v2"],
    telegram: ["telegram", "telegram-unipile"],
    "telegram-unipile": ["telegram", "telegram-unipile"],
    "webphone-kirmizisantral": ["webphone-kirmizisantral", "webphone-telnyx"],
    "webphone-telnyx": ["webphone-telnyx", "webphone-kirmizisantral"],
    "whatsapp-business-api": ["whatsapp-business-api", "whatsapp-business-api-supsis"],
};

const PLAN_TYPES = {
    "whatsapp-v2": "whatsapp",
    "whatsapp-business-api": "whatsapp-business",
    "whatsapp-business-api-supsis": "whatsapp-business",
    "whatsapp-unipile": "whatsapp",
    "instagram-v2": "instagram",
    "telegram-unipile": "telegram",
    "linkedin-unipile": "linkedin",
    "webphone-kirmizisantral": "webphone",
    "webphone-telnyx": "webphone",
};

const isLimited = (maxValue = 0, currentValue) => {
    console.log("isLimited", maxValue, currentValue);
    return maxValue === -1 ? false : currentValue >= maxValue;
};

class SiteFeatures {
    constructor() {
        const automationRoutes = AutomationMenuItems();
        const isAutomationRoute = (route) => {
            const extraRoutes = [
                "automations",
                "automation-design-block",
                "automation-design-flow",
                "automation-design",
            ];
            return [...extraRoutes, ...automationRoutes.map((r) => `automations-${r.key}`)].includes(route.name);
        };
        const fn = (route) => {
            store.dispatch("app/setUpgrade", {
                enabled: false,
            });
            if (store.state.site.initializedFeatures) {
                if (route.name === "ticket") {
                    return this.beforeLoadTicketPage();
                } else if (route.name === "tasks") {
                    return this.beforeLoadTaskPage();
                } else if (route.name === "calendar") {
                    return this.beforeLoadCalenderPage();
                } else if (route.name === "mails") {
                    return this.beforeLoadMailPage();
                } else if (route.name === "chat" && route.query.tab === "teamChat") {
                    return this.beforeLoadTeamChatPage("chat-overlay");
                } else if (route.name === "teamChat") {
                    return this.beforeLoadTeamChatPage();
                } else if (route.name === "integrations-webhook-new") {
                    return this.beforeLoadWebhookPage();
                } else if (route.name === "integrations-webhook") {
                    return this.beforeLoadWebhookPage();
                } else if (route.name === "integrations-mail") {
                    return this.beforeLoadMailIntegrationPage();
                } else if (route.name === "chat" && route.query.tab === "8") {
                    return this.beforeLoadCalenderPage("chat-overlay");
                } /*else if (route.name === "whatsapp-v2") {
                    return this.beforeLoadIntegrationPage(null, "whatsapp-v2", "whatsapp");
                } else if (route.name === "whatsapp") {
                    return this.beforeLoadIntegrationPage(null, "whatsapp", "whatsapp");
                } else if (route.name === "whatsapp-business-api") {
                    return this.beforeLoadIntegrationPage(null, "whatsapp-business-api", "whatsapp-business");
                } else if (route.name === "instagram") {
                    return this.beforeLoadIntegrationPage(null, "instagram", "instagram");
                } else if (route.name === "messenger") {
                    return this.beforeLoadIntegrationPage(null, "messenger", "messenger");
                } else if (route.name === "trendyol") {
                    return this.beforeLoadIntegrationPage(null, "trendyol", "trendyol");
                } */ else if (route.name === "sms-postacell") {
                    return this.beforeLoadIntegrationPage(null, "sms-postacell");
                } else if (["/contents/templates", "/contents"].includes(route.path)) {
                    return this.beforeLoadReadyContents("content-overlay");
                } else if (route.path.startsWith("/automations") && isAutomationRoute(route)) {
                    return this.beforeLoadAutomationPage();
                } else if (["form", "buildForm", "formInbox"].includes(route.name)) {
                    return this.beforeLoadFormPage();
                } else if (route.path.startsWith("/tables")) {
                    return this.beforeLoadCustomerTablePage();
                } else if (route.name === "settings-access-control") {
                    return this.beforeLoadAccessControlPage("settings-overlay");
                }
            }
        };
        store.watch((state) => state.app.route, fn, {
            deep: true,
        });

        store.watch(
            (state) => state.site.initializedFeatures,
            (val) => {
                if (val) {
                    fn(store.state.app.route);
                }
            }
        );

        store.watch(
            (state) => state.site.features,
            () => {
                fn(store.state.app.route);
            },
            { deep: true }
        );

        store.watch(
            (state) => state.mail.totalMailCount,
            () => {
                fn(store.state.app.route);
            },
            { deep: true }
        );
    }

    static create() {
        singletonInstance = singletonInstance || new SiteFeatures();
        return singletonInstance;
    }

    features() {
        return store.state.site.initializedFeatures ? store.state.site.features : {};
    }

    getFeature(key) {
        let feature = _.get(this.features(), key);
        return feature;
    }

    /**
     *
     * @param plan
     * @param feature
     * @param type
     * @param name = ["maxAgentCount", "maxTriggerCount", "visitorStartChat", "voiceCalling", "videoCalling", "fileAndVoiceMessage", "autoTranslation", "telegramEntegration", "chatCopilot", "calenderEntegration", "mailEntegration", "smsEntegration", "ticketSystem", "taskManagementEntegration", "webhookEntegration", "readyContents", "automationEntegration", "customerTablesEntegration", "formEntegration", "maxFormLimit", "maxFormFieldLimit", "maxCustomerTableCount", "maxCustomerTableFieldCount", "maxCustomerTableViewCount", "maxCustomerTableRecordCount", "maxAutomationButton", "automationTimerBase", "automationEventBase", "automationWebhookBase", "automationButtonBase", "liveScore", "multipleChatWindow", "maxTaskWorkflowLimit", "maxTaskColumnLimit", "maxTaskRowLimit", "maxDepartmentLimit", "maxRoleLimit", "maxReadyContentsLimit", "excelDownload", "customerGroup", "maxAgentCount", "maxMailCount", "maxWhatsappChannel", "maxBusinessWhatsappChannel", "maxInstagramChannel", "maxMessengerChannel", "maxTelegramChannel", "maxTrendyolChannel", "maxMetaLeadChannel"]
     * @returns {boolean}
     */
    upgradeEnabled(plan, feature, type, name) {
        store.dispatch("app/setUpgrade", {
            enabled: SYSTEM_ENABLED,
            type,
            plan,
            feature,
            name,
        });
        return false;
    }

    checkBeforeSubmit(plan, val, fn, feature, name) {
        const isRoot = store.state.auth.adminUser != null || !store.state.site.initializedFeatures;
        return val || isRoot || !SYSTEM_ENABLED ? fn() : this.upgradeEnabled(plan, feature, "modal", name);
    }

    checkBeforeSubmitOverlay(plan, feature, val, type = "overlay", name) {
        if (!val) this.upgradeEnabled(plan, feature, type, name);
    }

    beforeCreateAgent(fn) {
        const agentCount = store.state.user.activeUserCount;
        const feature = this.getFeature("maxAgentCount") || 0;
        this.checkBeforeSubmit("supsis", !isLimited(feature, agentCount), fn, undefined, "maxAgentCount");
    }

    beforeCreateIntegrationChannel(fn, integrationType) {
        const types = INTEGRATION_CHANNEL_TYPES[integrationType] || [integrationType];
        let channelCount = store.state.channel.channels.filter((channel) => types.includes(channel.type)).length;
        if (types.includes("telegram")) {
            const telegramBotFatherEnabled = store.getters["setting/telegramEnabled"];
            if (telegramBotFatherEnabled) channelCount = channelCount + 1;
        }
        const feature = this.getFeature(INTEGRATION_CHANNEL_FEATURE[integrationType]) || 0;
        this.checkBeforeSubmit(
            PLAN_TYPES[integrationType] || integrationType,
            !isLimited(feature, channelCount),
            fn,
            undefined,
            INTEGRATION_CHANNEL_FEATURE[integrationType]
        );
    }

    beforeChangeBrandLogo(fn) {
        const feature = this.getFeature("removeSupsisLogo");
        this.checkBeforeSubmit("supsis", feature, fn, "logo-remove", "removeSupsisLogo");
        return feature;
    }

    beforeCreateTrigger(fn) {
        const triggerCount = store.state.trigger.trigger.length;
        const feature = this.getFeature("maxTriggerCount") || 0;
        this.checkBeforeSubmit("supsis", !isLimited(feature, triggerCount), fn, undefined, "maxTriggerCount");
    }

    beforeVisitorStartChat(fn) {
        const feature = this.getFeature("visitorStartChat");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "visitorStartChat");
    }

    beforeStartVoiceCall(fn) {
        const feature = this.getFeature("voiceCalling");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "voiceCalling");
    }

    beforeStartVideoCall(fn) {
        const feature = this.getFeature("videoCalling");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "videoCalling");
    }

    beforeSendFileMessage(fn) {
        const feature = this.getFeature("fileAndVoiceMessage");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "fileAndVoiceMessage");
    }

    beforeAutoTranslation(fn) {
        const feature = this.getFeature("autoTranslation");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "autoTranslation");
    }

    beforeUseChatCopilot(fn) {
        const feature = this.getFeature("chatCopilot");
        this.checkBeforeSubmit("supsis", feature, fn, "ai-assistant", "chatCopilot");
    }

    isChatCopilotEnabled(fn) {
        const feature = this.getFeature("chatCopilot");
        if (feature) fn();
    }

    beforeFetchCalendar(fn) {
        const feature = this.getFeature("calenderEntegration");
        if (feature) fn();
    }

    beforeClickEmailFn(fn) {
        const feature = this.getFeature("mailEntegration");
        this.checkBeforeSubmit("supsis", feature, fn, "mail-entegration", "mailEntegration");
    }

    beforeClickSmsFn(fn) {
        const feature = this.getFeature("smsEntegration");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "smsEntegration");
    }

    beforeLoadTicketPage() {
        const feature = this.getFeature("ticketSystem");
        this.checkBeforeSubmitOverlay("supsis", "ticket-system", feature);
    }

    beforeLoadTaskPage() {
        const feature = this.getFeature("taskManagementEntegration");
        this.checkBeforeSubmitOverlay("supsis", "task-management", feature);
    }

    beforeLoadCalenderPage(type) {
        const feature = this.getFeature("calenderEntegration");
        this.checkBeforeSubmitOverlay("supsis", undefined, feature, type, "calendar");
    }

    beforeLoadIntegrationPage(fn, integrationType, type = "supsis") {
        const feature =
            this.getFeature(INTEGRATION_PAGE_FEATURE[integrationType]) || this.getFeature("allEntegrations");
        this.checkBeforeSubmitOverlay(type, undefined, feature);
    }

    beforeLoadMailPage() {
        const feature = this.getFeature("mailEntegration");
        const maxMailCount = this.getFeature("maxMailCount") || 0;
        const mailCount = store.state.mail.totalMailCount;
        const type = feature ? (!isLimited(maxMailCount, mailCount) ? "overlay" : "overlay-limited") : "overlay";
        const val = feature ? !isLimited(maxMailCount, mailCount) : feature;
        this.checkBeforeSubmitOverlay("mail", "mail-entegration", val, type, "mail");
    }

    beforeLoadMailIntegrationPage() {
        const feature = this.getFeature("mailEntegration");
        this.checkBeforeSubmitOverlay("mail", "mail-entegration", feature);
    }

    beforeLoadTeamChatPage(type) {
        const feature = this.getFeature("teamChatEntegration");
        this.checkBeforeSubmitOverlay("supsis", "team-integration", feature, type);
    }

    beforeLoadWebhookPage() {
        const feature = this.getFeature("webhookEntegration") || this.getFeature("allEntegrations");
        this.checkBeforeSubmitOverlay("supsis", "webhook-integration", feature);
    }

    beforeLoadReadyContents(type) {
        const feature = this.getFeature("readyContents");
        this.checkBeforeSubmitOverlay("supsis", undefined, feature, type, "ready-contents");
    }

    beforeLoadAutomationPage() {
        const feature = this.getFeature("automationEntegration");
        this.checkBeforeSubmitOverlay("automation", undefined, feature, "overlay", "automation");
    }

    beforeLoadCustomerTablePage() {
        const feature = this.getFeature("customerTablesEntegration");
        this.checkBeforeSubmitOverlay("customer-tables", undefined, feature, "overlay", "customer-tables");
    }

    beforeLoadFormPage() {
        const feature = this.getFeature("formEntegration");
        this.checkBeforeSubmitOverlay("form", undefined, feature, "overlay", "form");
    }

    beforeCreateForm(fn) {
        const feature = this.getFeature("maxFormLimit");
        const formCount = store.state.forms.totalCount;
        this.checkBeforeSubmit("form", !isLimited(feature, formCount), fn, undefined, "maxFormLimit");
    }

    beforeCreateFormField(fn, currentFieldCount) {
        const feature = this.getFeature("maxFormFieldLimit");
        this.checkBeforeSubmit("form", !isLimited(feature, currentFieldCount), fn, undefined, "maxFormFieldLimit");
    }

    beforeCreateTable(fn) {
        const feature = this.getFeature("maxCustomerTableCount");
        const tableCount = store.state.table.totalTable;
        this.checkBeforeSubmit(
            "customer-tables",
            !isLimited(feature, tableCount),
            fn,
            undefined,
            "maxCustomerTableCount"
        );
    }

    beforeCreateTableField(fn, currentTableFieldCount) {
        const feature = this.getFeature("maxCustomerTableFieldCount");
        this.checkBeforeSubmit(
            "customer-tables",
            !isLimited(feature, currentTableFieldCount),
            fn,
            undefined,
            "maxCustomerTableFieldCount"
        );
    }

    beforeCreateTableView(fn, currentTableViewCount) {
        const feature = this.getFeature("maxCustomerTableViewCount");
        this.checkBeforeSubmit(
            "customer-tables",
            !isLimited(feature, currentTableViewCount),
            fn,
            undefined,
            "maxCustomerTableViewCount"
        );
    }

    beforeCreateTableRecord(fn, currentTableRecordCount) {
        const feature = this.getFeature("maxCustomerTableRecordCount");
        this.checkBeforeSubmit(
            "customer-tables",
            !isLimited(feature, currentTableRecordCount),
            fn,
            undefined,
            "maxCustomerTableRecordCount"
        );
    }

    isTableRecordLimitExceeded(currentTableRecordCount) {
        const feature = this.getFeature("maxCustomerTableRecordCount");
        return isLimited(feature, currentTableRecordCount);
    }

    beforeUseReadyContents(fn) {
        const feature = this.getFeature("readyContents");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "readyContents");
    }

    isReadyContentsEnabled(fn) {
        const feature = this.getFeature("readyContents");
        if (feature) fn();
    }

    beforeCreateAutomationBlock(fn, currentBlockSize) {
        if (store.state.app.debugMode) {
            fn();
        } else {
            const feature = this.getFeature("maxAutomationButton");
            return this.checkBeforeSubmit(
                "automation",
                !isLimited(feature, currentBlockSize),
                fn,
                undefined,
                "maxAutomationButton"
            );
        }
    }

    beforeCreateTimerAutomation(fn) {
        const feature = this.getFeature("automationTimerBase");
        return this.checkBeforeSubmit("automation", feature, fn, undefined, "automationTimerBase");
    }

    beforeCreateEventBasedAutomation(fn) {
        const feature = this.getFeature("automationEventBase");
        return this.checkBeforeSubmit("automation", feature, fn, undefined, "automationEventBase");
    }

    beforeCreateWebhookAutomation(fn) {
        if (store.state.app.debugMode) {
            fn();
        } else {
            const feature = this.getFeature("automationWebhookBase");
            return this.checkBeforeSubmit("automation", feature, fn, undefined, "automationWebhookBase");
        }
    }

    beforeCreateButtonAutomation(fn) {
        const feature = this.getFeature("automationButtonBase");
        return this.checkBeforeSubmit("automation", feature, fn, undefined, "automationButtonBase");
    }

    beforeRunButtonAutomation(fn) {
        const features = store.state.site.features;
        const feature = _.get(features, "maxAutomationTask", 0);
        const totalAutomationUsage = store.state.site.conversationStatistics.totalAutomationUsage;
        return this.checkBeforeSubmit(
            "automation",
            !isLimited(feature, totalAutomationUsage),
            fn,
            undefined,
            "automationMaxUsageCount"
        );
    }

    beforeOpenLiveScore(fn) {
        const feature = this.getFeature("liveScore");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "liveScore");
    }

    beforeOpenMultipleChatWindow(fn) {
        const feature = this.getFeature("multipleChatWindow");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "multipleChatWindow");
    }

    beforeCreateTaskWorkflow(fn) {
        const feature = this.getFeature("maxTaskWorkflowLimit");
        const workflowCount = store.state.tasks.workflowCount;
        this.checkBeforeSubmit("tasks", !isLimited(feature, workflowCount), fn, undefined, "maxTaskWorkflowLimit");
    }

    beforeCreateTaskColumn(fn, pipelineCount) {
        const feature = this.getFeature("maxTaskColumnLimit");
        this.checkBeforeSubmit("tasks", !isLimited(feature, pipelineCount), fn, undefined, "maxTaskColumnLimit");
    }

    beforeCreateTaskRow(fn, taskCount) {
        const feature = this.getFeature("maxTaskRowLimit");
        this.checkBeforeSubmit("tasks", !isLimited(feature, taskCount), fn, undefined, "maxTaskRowLimit");
    }

    beforeCreateDepartment(fn, totalCount) {
        const feature = this.getFeature("maxDepartmentLimit");
        this.checkBeforeSubmit("supsis", !isLimited(feature, totalCount), fn, undefined, "maxDepartmentLimit");
    }

    beforeCreateRole(fn, totalCount) {
        const feature = this.getFeature("maxRoleLimit");
        this.checkBeforeSubmit("supsis", !isLimited(feature, totalCount), fn, undefined, "maxRoleLimit");
    }

    beforeCreateReadyContent(fn) {
        const feature = this.getFeature("maxReadyContentsLimit");
        const totalCount = store.state.content.contents.total;
        this.checkBeforeSubmit("supsis", !isLimited(feature, totalCount), fn, undefined, "maxReadyContentsLimit");
    }

    beforeDownloadExcel(fn) {
        const feature = this.getFeature("excelDownload");
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "excelDownload");
    }

    beforeCreateCustomerGroup(fn, disabledCb) {
        const feature = this.getFeature("customerGroup");
        if (!feature) disabledCb();
        this.checkBeforeSubmit("supsis", feature, fn, undefined, "customerGroup");
    }

    beforeCreateUserMail(fn) {
        const agentMailCount = store.state.mail.allMailAddresses.filter(
            (email) => email.type === "user" && !!email.user && !!email.isVerified && !email.isForward
        ).length;
        const feature = this.getFeature("maxAgentCount") || 0;
        this.checkBeforeSubmit("supsis", !isLimited(feature, agentMailCount), fn, undefined, "maxAgentCount");
    }

    beforeCreateVoiceAgentIntegration(fn) {
        const feature = this.getFeature("voiceAgentEntegration");
        console.log("beforeCreateVoiceAgentIntegration", {
            feature,
        });
        this.checkBeforeSubmit("voice-agent", feature, fn, undefined, "voiceAgentEntegration");
    }

    beforeLoadAccessControlPage(type) {
        const feature = this.getFeature("accessControl");
        this.checkBeforeSubmitOverlay("supsis", "access-control", feature, type, "accessControl");
    }

    beforeCreateVoiceClone(fn, customAgentCount) {
        const feature = this.getFeature("maxVoiceAgentVoiceCloning");
        this.checkBeforeSubmit(
            "voice-agent",
            !isLimited(feature, customAgentCount),
            fn,
            undefined,
            "maxVoiceAgentVoiceCloning"
        );
    }

    beforeCreateVoiceAgent(fn, count) {
        const feature = this.getFeature("maxVoiceAgentActiveCount");
        this.checkBeforeSubmit("voice-agent", !isLimited(feature, count), fn, undefined, "maxVoiceAgentActiveCount");
    }

    beforeCreateArtificialIntelligence(fn) {
        const feature = this.getFeature("chatCopilot");
        this.checkBeforeSubmit("artificial-intelligence", feature, fn, undefined, "chatCopilot");
    }

    beforeCreateTableModule(fn) {
        const feature = this.getFeature("customerTableModuleFeature");
        this.checkBeforeSubmit("customer-tables", feature, fn, undefined, "customerTableModuleFeature");
    }

    beforeCreateTableReport(fn) {
        const feature = this.getFeature("customerTableReportFeature");
        this.checkBeforeSubmit("customer-tables", feature, fn, undefined, "customerTableReportFeature");
    }

    isVoiceConfigurationEnabled() {
        const feature = this.getFeature("whatsappVoiceCalling");
        return feature;
    }
}

export default SiteFeatures;
